// extracted by mini-css-extract-plugin
export default {"wrap":"ox-z","fullWidth":"px-z","items":"qx-z","featureCss":"rx-z","disabled":"sx-z","imgCss":"tx-z"};